import { Injectable, signal } from '@angular/core';

export type ForbiddenCode = 'RBAC' | 'BRANCH_ASSIGNMENT_REQUIRED' | 'BRANCH_NOT_ASSIGNED' | 'NOT_FOUND';

@Injectable({ providedIn: 'root' })
export class ForbiddenStore {
  readonly code = signal<ForbiddenCode | null>(null);
  readonly resource = signal<string | undefined>(undefined);

  set(code: ForbiddenCode | null, resource?: string): void {
    this.code.set(code);
    this.resource.set(resource);
  }

  clear(): void {
    this.code.set(null);
    this.resource.set(undefined);
  }
}
